import { render, staticRenderFns } from "./SchoolCommonInfo.vue?vue&type=template&id=57d00200&scoped=true&"
import script from "./SchoolCommonInfo.vue?vue&type=script&lang=js&"
export * from "./SchoolCommonInfo.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCommonInfo.vue?vue&type=style&index=0&id=57d00200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d00200",
  null
  
)

export default component.exports